import ResponsiveTable from "../table"
import { PropTypes } from 'prop-types';

const VacanciesTable = ({title,header,content}) => {
  return (
    <>
     <h1 className="text-4xl font-bold text-center  text-slate-900">{title}</h1>
     <ResponsiveTable headers={header} contents={content} headerBg="bg-[#2C2E82] border-[#919191] text-white" />
    </>
  )
}
VacanciesTable.propTypes = {
    title: PropTypes.string.isRequired,
    header: PropTypes.array.isRequired,
    content: PropTypes.array.isRequired
}
export default VacanciesTable